import React from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { ArticleCard } from 'site-modules/editorial/components/article-card/article-card';
import { breakpoints } from 'client/utils/bootstrap';
import { Carousel } from 'site-modules/shared/components/carousel/carousel';

import './article-cards.scss';

const carouselOptions = {
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  responsive: [
    {
      breakpoint: breakpoints.md,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 1,
      },
    },
  ],
};

export function ArticleCards({ entry }) {
  const cards = entry.children();
  const entryData = entry.getAllMetadata();
  const title = {
    name: entryData.categoryId,
    link: entryData.allText,
    linkUrl: entryData.allLink,
  };
  return (
    cards.length > 0 && (
      <div className="article-cards">
        <Row>
          <Col xs={12}>
            <div className="article-cards-title pe-md-1">
              <a href={title.linkUrl} className="small ms-0_5 py-0_25 py-md-0_5 article-title-link float-end">
                {title.link}
              </a>
              <h3 className="text-primary display-3 fw-bold">{title.name}</h3>
            </div>
          </Col>
        </Row>
        <Carousel variableWidth swipeToSlide {...carouselOptions}>
          {cards.map((articleCard, key) => (
            <div className="slide pe-1" key={articleCard.id}>
              <ArticleCard entry={articleCard} data-index={key} textRight isLabelHidden />
            </div>
          ))}
        </Carousel>
      </div>
    )
  );
}
ArticleCards.propTypes = {
  entry: PropTypes.shape({
    categoryId: PropTypes.string,
    allText: PropTypes.string,
    allLink: PropTypes.string,
  }).isRequired,
};
